<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { itemtransactionService } from "../../../../services/inventoryservice/itemtransaction.service";
import { supplierService } from "../../../../services/inventoryservice/supplier.service";
import { servicehelpers } from "../../../../services/servicehelpers";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
import Screen from "../../../../components/screen";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Invoice List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      invoiceData: {},
      supplierData: {},
      statusData: {},
      typeData: {},
      fetchingStats: false,
      title: "Invoice List",

    };
  },
  mounted() {
    this.loadingSupplierData();
    this.loadingStatusData();
    this.loadingTypeData();
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      itemtransactionService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.invoiceData = response;
        });
    },

    loadingSupplierData: function() {
      supplierService.getList("?page=0")
        .then(response => {
          this.supplierData = response;

        });
    },

    loadingStatusData: function() {
      servicehelpers.getItemTransactionStatus()
        .then(response => {
          this.statusData = response;

        });
    },

    loadingTypeData: function() {
      servicehelpers.getItemTransactionType()
        .then(response => {
          this.typeData = response;

        });
    },

    deleted: function(id) {
      itemtransactionService.remove(id)
        .then(response => {
        
          // this.invoiceData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {

      console.log(JSON.stringify(param));
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "invoice-add",
          });
    },

    moreClick: function(event, id) {
      console.log(event, id);
      if(event == 'in-approve') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.unkeep-message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            itemtransactionService.approveIn(id).then(response => {
              if(response.status == 200){
                this.loadingData();
              }
            });
          }
        });
      } else if(event == 'out-approve') {
          itemtransactionService.approveOutReceiveIn(id).then(response => {
            if(response.status == 200){
              this.loadingData();
            }
          });
      } else if(event == 'receive') {
        itemtransactionService.approveOutReceiveIn(id).then(response => {
          if(response.status == 200){
            this.loadingData();
          }
        });
      } else if(event == 'paid') {
        itemtransactionService.pay(id).then(response => {
          if(response.status == 200){
            this.loadingData();
          }
        });
      }
    },
  }           //v-bind:edit="{link: 'invoice-edit'}"
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'invoice-add'}" :title="$t('invoice.text')" />
    <List v-bind:dataList="invoiceData" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'type', color: 'type_color'},{name: 'status', color: true},  {name: 'total', type: 'currency', sign: '$', decimal: '.0000'}]"
          v-bind:fields="[ `number: ${$t('invoice.number')}`, `supplier: ${$t('supplier.text')}`, `transaction_date: ${$t('invoice.date')}`, `type: ${$t('invoice.type')}`, 
            `ref: ${$t('invoice.ref')}`, `total: ${$t('invoice.total')}`, `status: ${$t('invoice.status')}`, `user: ${$t('setting.security.user.text')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:view="{link: 'item-view'}"

          @more="moreClick"
          v-bind:more="{
            sub: [{
              name: 'invoice.print', icon: 'bx bx-printer', link: 'invoice-request', column: 'id', target: '_blank'
            },{
              name: 'invoice.approve', icon: 'bx bx-list-check', action: 'in-approve', column: 'id', show: {column: 'item_transaction_status_id', value: 1}
            }, {
              name: 'invoice.receive', icon: 'bx bxs-component', action: 'receive', column: 'id', show: {column: 'item_transaction_status_id', value: 2}
            }, {
              name: 'invoice.approve', icon: 'bx bx-list-check', action: 'out-approve', column: 'id', show: {column: 'item_transaction_status_id', value: 6}
           
            }] 
          }"
          v-bind:filter="{
            search: ['item_transactions.number', 'item_transactions.notation', 'item_transactions.ref'],
            dropdown: [{
              title: 'supplier.text',
              field: 'item_transactions.supplier_id',
              data: this.supplierData.data,
              width: 2
            }, {
              title: 'invoice.type',
              field: 'item_transactions.type_id',
              data: this.typeData.data,
            }, { 
              title: 'invoice.status',
              field: 'item_transactions.item_transaction_status_id',
              data: this.statusData.data,
            }]
          }"
          
    />      
  </Layout>
</template>